import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=f60035c8&scoped=true&"
import script from "./BaseDialog.vue?vue&type=script&lang=ts&"
export * from "./BaseDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=f60035c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60035c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardActions,VCardTitle,VIcon})
